import { generateMutation, generateQuery, MutationType, QueryType } from "typegraph";
import { Entity, Field } from "typegraph";

import { IDictionaryEntry, IDictionaryRemoveParams } from "core/components/label/ILabel";
import Service from "core/decorators/Service";
import ILocalizationService from "core/service/localization/ILocalizationService";
import XHRResolverService from "core/service/resolver/impl/XHRResolver.service";
import { actionResultFrom } from 'core/util/MutationUtil';
import ServiceRegistry from "core/util/ServiceRegistry";

// tslint:disable:max-classes-per-file

@Entity({
	many: "dictionaryEntries",
	create: "dictionaryEntryCreate",
	update: "dictionaryEntryUpdate",
	delete: "dictionaryEntryDelete"
})
class DictionaryEntry {

	@Field()
	public key: string;

	@Field()
	public instance: string;

	@Field()
	public language: string;

	@Field()
	public value: string;

	@Field()
	public type: string;

}

@Entity({
	many: "dictionaryEntriesUser",
})
class DictionaryEntryUser {

	@Field()
	public key: string;

	@Field()
	public instance: string;

	@Field()
	public language: string;

	@Field()
	public value: string;

	@Field()
	public type: string;

}

@Service()
export default class DefaultLocalizationService extends ILocalizationService {

	public loadEntries(language: string): Promise<object> {
		// cached manually, only called on language change
		const resolver = ServiceRegistry.get(XHRResolverService);

		const query = generateQuery(DictionaryEntry, QueryType.MANY, {params: {language: language || null}}, "entries");

		return resolver.execute(query);
	}

	public loadUserEntries(language?: string): Promise<object> {
		const resolver = ServiceRegistry.get(XHRResolverService);

		const query = generateQuery(DictionaryEntryUser, QueryType.MANY, {params: {}}, "entries");

		return resolver.execute(query);
	}

	public saveEntry(entry: IDictionaryEntry): Promise<object> {
		const resolver = ServiceRegistry.get(XHRResolverService);

		const mutation = generateMutation(actionResultFrom(DictionaryEntry as any), MutationType.CREATE, {params: {
			key: entry.key,
			language: entry.language,
			instance: entry.instance || null,
			value: entry.value || "",
			type: entry.type || ""
		}});

		return resolver.execute(mutation);
	}

	public deleteEntry(params: IDictionaryRemoveParams): Promise<object> {
		const resolver = ServiceRegistry.get(XHRResolverService);

		const mutation = generateMutation(actionResultFrom(DictionaryEntry as any), MutationType.DELETE, {params});

		return resolver.execute(mutation);
	}

	public getDictionary(): Promise<object> {

		// bypass IQueryService and use the XHRResolver directly for its caching policy
		// this is generally not good practice
		const resolver = ServiceRegistry.get(XHRResolverService);

		const query = `
			query {
				dictionary {
					key
					value
				}
			}
		`;

		return resolver.execute(query);
	}

	public formatDate(): Date {
		// format using react-intl
		return new Date();
	}

	public formatTime(): string {
		// format using react-intl
		return "hi";
	}

	public getServiceId(): string {
		return ILocalizationService.DEFAULT_ID;
	}

}



// WEBPACK FOOTER //
// ./src/core/service/localization/impl/DefaultLocalization.service.ts